import { Outlet } from 'react-router-dom';

const EquipmentUseAndPerformanceReportsPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
}

export default EquipmentUseAndPerformanceReportsPage;